import { render, staticRenderFns } from "./TableListPageTemplate.vue?vue&type=template&id=98334946&scoped=true&"
import script from "./TableListPageTemplate.vue?vue&type=script&lang=js&"
export * from "./TableListPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TableListPageTemplate.vue?vue&type=style&index=0&id=98334946&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98334946",
  null
  
)

export default component.exports